import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BaasicButton, BasicTextArea } from 'core/components';

function NikoTemplateInvoiceNoteModalTemplate({ nikoTemplateInvoiceNoteModalStore, t }) {
    const {
        form,
        modalParams,
        isEditDisabled
    } = nikoTemplateInvoiceNoteModalStore;

    const onKeyDown = (e) => {
        if (e.keyCode == 13) {
            e.preventDefault();
            form.onSubmit(e);
        }
    }

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Invoice Note</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BasicTextArea field={form.$('invoiceNote')} onKeyDown={onKeyDown} isFocus={true} disabled={isEditDisabled} />
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                    disabled={form.submitting || form.validating || isEditDisabled}
                />
                <BaasicFormControls
                    form={form}
                    className='btn btn--med btn--primary'
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating || isEditDisabled}
                    label={t('EDIT_FORM_LAYOUT.SAVE')}
                />
            </div>
        </section>
    )
}

NikoTemplateInvoiceNoteModalTemplate.propTypes = {
    nikoTemplateInvoiceNoteModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(NikoTemplateInvoiceNoteModalTemplate);
